import { api } from "@/api";

class API {
  static getProfileSuggestion() {
    return api.get(`/v1/perfisacesso/suggest/`);
  }

  static getStructureSuggestion() {
    return api.get(`/v1/perfisacesso/estruturas/suggest/`);
  }

  static getProfileList(payload) {
    return api.get(`/v1/perfisacesso/`, { params: payload });
  }

  static getProfile(profileId) {
    return api.get(`/v1/perfisacesso/${profileId}/`);
  }

  static postProfile(payload) {
    return api.post(`/v1/perfisacesso/`, payload);
  }

  static putProfile({ profileId, payload }) {
    return api.put(`/v1/perfisacesso/${profileId}`, payload);
  }

  static getModuleList() {
    return api.get(`/v1/modulos/`);
  }
}

export default API;
